import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const categoryLabels: Record<string, string> = {
  'ru-men-jiao-cheng': '入门教程',
  'yan-zou-ji-qiao': '演奏技巧',
  'xuan-gou-zhi-nan': '选购指南',
  'pin-pai-dui-bi': '品牌对比',
  'li-shi-qi-yuan': '历史起源',
  'wei-hu-bao-yang': '维护保养',
};

const articleImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=A%20hexagonal%20traditional%20Chinese%20string%20instrument%20liujiaoqin%20displayed%20on%20a%20warm%20wooden%20stand%20with%20soft%20natural%20lighting%2C%20a%20pair%20of%20bamboo%20mallets%20resting%20beside%20it%2C%20minimalist%20studio%20setting%20with%20cream%20background%2C%20elegant%20and%20educational%20photography%20style%20high%20detail%20clean%20composition&width=600&height=400&seq=article-1&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=Close-up%20of%20hands%20holding%20bamboo%20mallets%20over%20a%20hexagonal%20string%20instrument%20body%20demonstrating%20proper%20grip%20technique%2C%20soft%20natural%20light%20from%20left%20side%2C%20warm%20cream%20colored%20background%2C%20educational%20demonstration%20photography%20clean%20minimalist%20aesthetic&width=600&height=400&seq=article-2&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=A%20student%20sitting%20at%20a%20hexagonal%20string%20instrument%20with%20sheet%20music%20and%20a%20metronome%20on%20the%20music%20stand%2C%20warm%20afternoon%20light%20streaming%20through%20a%20window%2C%20cozy%20home%20practice%20setting%20cream%20walls%20natural%20candid%20photography&width=600&height=400&seq=article-3&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=A%20young%20child%20around%208%20years%20old%20sitting%20at%20a%20small%20hexagonal%20instrument%20with%20a%20smiling%20parent%20beside%20them%2C%20bright%20and%20cheerful%20home%20environment%2C%20soft%20diffused%20lighting%20cream%20and%20warm%20wood%20tones%20heartwarming%20educational%20scene&width=600&height=400&seq=article-4&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=Professional%20musician%20hands%20in%20motion%20playing%20a%20hexagonal%20string%20instrument%20with%20mallets%2C%20dynamic%20action%20shot%20capturing%20the%20moment%20of%20striking%20strings%2C%20dramatic%20side%20lighting%20creating%20depth%2C%20dark%20warm%20background%20with%20cream%20accents%20artistic%20performance&width=600&height=400&seq=article-5&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=An%20array%20of%20different%20mallets%20and%20beaters%20arranged%20neatly%20beside%20a%20hexagonal%20instrument%2C%20showing%20various%20materials%20and%20sizes%2C%20warm%20studio%20lighting%2C%20shallow%20depth%20of%20field%20focusing%20on%20texture%20details%20professional%20equipment&width=600&height=400&seq=article-6&orientation=landscape',
};

export default function FeaturedArticles() {
  const featured = articles.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              精选文章
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              最新最受欢迎的六角琴知识文章
            </p>
          </div>
          <Link
            to="/category/ru-men-jiao-cheng"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="h-44 md:h-48 w-full overflow-hidden">
                <img
                  src={articleImages[article.id]}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded whitespace-nowrap">
                    {categoryLabels[article.category]}
                  </span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                  <span>{article.author}</span>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}